import { FieldValue } from '../../data-objects'
import { DefinitionUtils } from '../utils'
import { FieldDefinition } from './field-definition'

export class AnyOfFieldDefinition extends FieldDefinition {
  public valueTypes: FieldDefinition[]

  constructor(field: AnyOfFieldDefinition) {
    super(field)
    this.valueTypes = field.valueTypes ? DefinitionUtils.mapFieldDefinitions(field.valueTypes) : []
  }

  public getFieldValue(value?: any): FieldValue<any> {
    let fieldDefinition: FieldDefinition | undefined

    if (value) {
      /*anyof value has a special attribute that specifies the type of the subfield. Use this in order to retrieve the proper fieldDefinition class*/
      switch (value.type) {
        case 'StringValue':
          fieldDefinition = this.valueTypes.find((t) => t.fieldDefinitionType == 'String')
          break
        case 'DateTimeValue':
          fieldDefinition = this.valueTypes.find((t) => t.fieldDefinitionType == 'DateTime')
          break
        case 'DurationValue':
          fieldDefinition = this.valueTypes.find((t) => t.fieldDefinitionType == 'Duration')
          break
        case 'LookupValue':
          fieldDefinition = this.valueTypes.find((t) => t.fieldDefinitionType == 'Lookup')
          break
        case 'NumericValue':
          fieldDefinition = this.valueTypes.find((t) => t.fieldDefinitionType == 'Numeric')
          break
        case 'OptionSetValue':
          fieldDefinition = this.valueTypes.find((t) => t.fieldDefinitionType == 'OptionSet')
          break
        case 'CodeableConceptValue':
          fieldDefinition = this.valueTypes.find((t) => t.fieldDefinitionType == 'CodeableConcept')
          break
        default:
          throw new Error(`AnyOf definition, unupported field: ${value.type}`)
      }

      /*get field value from its own definition*/
      const fieldVal: FieldValue<any> = (fieldDefinition as FieldDefinition).getFieldValue()
      fieldVal.isAnyOf = true
      return fieldVal
    }
    return undefined as any
  }
}
